export function ShareBar({ segments }: { segments: Array<{ value: number; className?: string; title?: string }> }): JSX.Element {
  const total = segments.reduce((s, x) => s + Math.max(0, x.value), 0) || 1;
  return (
    <div className="flex h-6 rounded overflow-hidden border border-border-subtle/50">
      {segments.map((seg, i) => {
        const pct = (Math.max(0, seg.value) / total) * 100;
        return (
          <div key={i}
            className={`${seg.className ?? 'bg-neon-cyan'} flex items-center justify-center text-[10px] font-mono font-bold text-bg-primary px-1`}
            style={{ width: `${pct}%` }} title={seg.title}>
            {pct >= 12 ? `${pct.toFixed(0)}%` : ''}
          </div>
        );
      })}
    </div>
  );
}
